export default __webpack_public_path__ + "static/media/no_background.d0c94811.png";